import * as Tokens from '../utils/DesignTokens/tokens';
import prepareTheme from './prepareTheme';
const CompleteTheme = prepareTheme(Tokens);
const defaultTheme = CompleteTheme;
export default defaultTheme;
//# sourceMappingURL=defaultTheme.js.map